/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ startDate: NonNullable<unknown>, endDate: NonNullable<unknown> }} Kepler_Hydraulic_Analysis_DescriptionInputs */

const en_us2_kepler_hydraulic_analysis_description = /** @type {(inputs: Kepler_Hydraulic_Analysis_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The hydraulic analysis uses a digital twin to perform a series of tests to help you understand and optimize your collection system. This process will analyze the period of time between ${i?.startDate} and ${i?.endDate}.`)
};

const en_gb2_kepler_hydraulic_analysis_description = /** @type {(inputs: Kepler_Hydraulic_Analysis_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The hydraulic analysis uses a digital twin to perform a series of tests to help you understand and optimise your collection system. This process will analyse the period of time between ${i?.startDate} and ${i?.endDate}.`)
};

/**
* | output |
* | --- |
* | "The hydraulic analysis uses a digital twin to perform a series of tests to help you understand and optimize your collection system. This process will analyze..." |
*
* @param {Kepler_Hydraulic_Analysis_DescriptionInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const kepler_hydraulic_analysis_description = /** @type {((inputs: Kepler_Hydraulic_Analysis_DescriptionInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kepler_Hydraulic_Analysis_DescriptionInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_kepler_hydraulic_analysis_description(inputs)
	return en_us2_kepler_hydraulic_analysis_description(inputs)
});